import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EmployerMethodAPI } from '@app/models/role.model';
import { IEmployerPageSearchReq } from '@app/components/employer-page-search/interfaces/iemployer-page-search-req';


@Injectable({
  providedIn: 'root'
})
export class EmployerService {
  private BASE_URL_SERVICE: string = environment.endpoint.apiemployer;

  constructor(private http: HttpClient) { }

  databaseNotificactionRead(_idUser: any, _idEmployer: number, arrEmployee: any[]) {

    var req = {
      _idUser: _idUser,
      _idEmployer: _idEmployer,
      employee: arrEmployee
    }
      ;

    return this.http.post(this.BASE_URL_SERVICE + 'markNotificationAsRead/', req);
  }

  getEmployer(_idEmployer: number) {

    let req = {
      _idEmployer,
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployer/", req);
  }

  getEmployerNetwork(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployerNetwork/", req);
  }

  getEmployerListUser(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployerListUser/", req);
  }

  getEmployerListAll(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployerListAll/", req);
  }

  getEmployerProfile(employerProfileUrl: string, _idEmployee: number) {

    let req = {
      employerProfileUrl,
      _idEmployee
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployerProfile/", req);
  }

  getComplaintsNameUsers(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getComplaintsNameUsers/', req);
  }

  getResponsibleNames(_idEmployer: number, _idUser: number) {
    let req = { _idEmployer, _idUser };
    return this.http.post<any>(
      this.BASE_URL_SERVICE + 'getResponsibleNames/',
      req
    );
  }

  getComplaintMessages(_id: number) {
    let req = { _id };
    return this.http.post<any>(
      this.BASE_URL_SERVICE + 'getComplaintMessages/',
      req
    );
  }

  getUsersComplaintChange(req) {
    return this.http.post<any>(
      this.BASE_URL_SERVICE + 'getUsersComplaintChange/',
      req
    );
  }

  getNotificationRecipient(req) {
    return this.http.post<any>(
      this.BASE_URL_SERVICE + 'getNotificationRecipient/',
      req
    );
  }

  insertComplaintMessage(req) {
    return this.http.post<any>(
      this.BASE_URL_SERVICE + 'insertComplaintMessage/',
      req
    );
  }

  updateComplaintChannel(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'updateComplaintChannel/', req);
  }

  updateStatusNotification(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'updateStatusNotification/', req);
  }

  getEmployeeDatabase(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployeeDatabase/", req);
  }

  getInstitutionList(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getInstitutionList/", req);
  }

  getInstitutionListLanding(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getInstitutionListLanding/", req);
  }

  getInstitution(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getInstitution/", req);
  }

  getEmployerValidProfile(_id: number) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "getEmployerValidProfile/", { _id });
  }


  postEmployerFormBasic(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + EmployerMethodAPI.insertEmployerBasic, req);
  }

  putEmployerFormBasic(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + EmployerMethodAPI.updateEmployerBasic, req);
  }

  searchInstitutionProfile(req: IEmployerPageSearchReq) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "searchInstitutionProfile/", req);
  }

  searchInstitutionProHome() {
    return this.http.get<any>(this.BASE_URL_SERVICE + "searchInstitutionProHome/");
  }

  updateEmployer(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "updateEmployer/", req).toPromise();
  }

  updateEmployerComplaintProtocol(req: any) {
    return this.http
      .post<any>(
        this.BASE_URL_SERVICE + 'updateEmployerComplaintProtocol/',
        req
      )
      .toPromise();
  }

  updateEmployerComplaintConfiguration(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'updateEmployerComplaintConfiguration/', req).toPromise();
  }

  getEmployerComplaintProtocol(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployerComplaintProtocol/', req).toPromise();
  }

  getEmployerComplaintConfiguration(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployerComplaintConfiguration/', req).toPromise();
  }

  getEmployerComplaintProfile(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployerComplaintProfile/', req).toPromise();
  }

  searchComplaints(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchComplaints/', req);
  }

  searchGeneralNotification(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchGeneralNotification/', req);
  }

  searchComplaintNotification(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchComplaintNotification/', req);
  }

  updateBenefit(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "updateBenefit/", req).toPromise();
  }

  updateQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + "updateQuestion/", req).toPromise();
  }

  getMembershipDetail(_idEmployer) {
    return this.http.get<any>(this.BASE_URL_SERVICE + "membership_detail/" + `${_idEmployer}`).toPromise();
  }

  async getMembershipInfo(_idEmployer) {

    var resp = {
      type_account: 0,
      type_plan: 0,
      code_plan: 0,
      date_expiration: 0,
      date_renew: 0,
      date_current: 0,
      date_current_month_start: 0,
      date_current_month_end: 0,
      had_trial: 0,
      had_plan: 0,
      advice: {
        quota: 0,
        available: 0,
        unlimited: 0,
        current_month: 0,
        to_expire: 0,
        date_expiration: 0,
      },
      download:
      {
        quota: 0,
        current_month: 0,
        available: 0
      },
      invitation:
      {
        quota: 0,
        current_month: 0,
        available: 0
      },
      psycho_interview:
      {
        available: 0
      }
    };

    await this.http.get<any>(this.BASE_URL_SERVICE + "membership_info/" + `${_idEmployer}`).toPromise().then(res => {

      if (res.status_code !== 0) { return; }

      resp = res.membership;
    },
      () => {
        return;
      }
    )

    return resp;
  }

  saveMemberManagment(req: EmployeeMemberTeam) {

    if (req._id !== undefined && req._id > 0) {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'updateMember/', req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'saveMemberManagment/', req);
    }
  }

  saveMemberTeacher(req: EmployeeMemberTeam) {

    if (req._id !== undefined && req._id > 0) {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'updateMember/', req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'saveMemberTeacher/', req);
    }
  }

  deleteMemberManagment(_id: number, _idEmployer: number) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteMember/', { _id, _idEmployer });
  }

  deleteNotification(_id: number) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteNotification/', { _id });
  }

  validateNotificationName(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'validateNotificationName/', req);
  }


  searchPsychoInterview(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchPsychoInterview/', req);
  }

  searchEmployeeEmail(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchEmployeeEmail/', req);
  }

  searchUser(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchUser/', req);
  }

  saveManagerPosition(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'saveManagerPosition/', req);
  }

  searchManagerPosition(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchManagerPosition/', req);
  }

  saveManagerArea(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'saveManagerArea/', req);
  }

  searchManagerArea(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchManagerArea/', req);
  }

  saveManagerEmployee(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putManagerEmployee/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postManagerEmployee/', req);
    }
  }

  saveComplaintNotification(_id: number, req: any) {
    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putComplaintNotification/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postComplaintNotification/', req);
    }
  }

  searchManagerTeam(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchManagerTeam/', req);
  }

  deleteManagerEmployee(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteManagerEmployee/', req)
  }

  getConfigurationParam(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getConfigurationParam/', req);
  }

  saveManagerSupervisor(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postManagerEmployeeSupervisor/', req);
  }

  getStatusManager(_idUser) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getStatusManager/' + _idUser);
  }

  getStatusManagerAdmin(_idEmployer) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getStatusManagerAdmin/' + _idEmployer);
  }

  saveInterview(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'saveInterview/', req);
  }

}